export default {
  title: 'Your choices have been successfully saved.',
  information: 'Please note that it may take up to 30 days for your preferences to be updated.',
};
